import {HttpClient} from "~/infra/http-client";
import {makeCache} from "~/main/factories/infra/cache";

export const makeHttpClient = () => {
  const httpClient = new HttpClient();
  httpClient.setAuthorization(makeCache().getItem("GT_token"));

  return httpClient;
};
